import { combineReducers } from 'redux';

import { ZOOM_LEVELS, MIN_ZOOM, MAX_ZOOM, getZoomIndex } from '@/util/zoom.js';

const searchParams = new URLSearchParams(window.location.search);

export const defaultZoom = searchParams.has('zoom') ? Number(searchParams.get('zoom')) : 1;
export const defaultPanX = searchParams.has('x') ? -Number(searchParams.get('x')) : 0;
export const defaultPanY = searchParams.has('y') ? -Number(searchParams.get('y')) : 0;

const cameraReducer = combineReducers({

    size: function (state = { width: 0, height: 0 }, action) {
        switch (action.type) {    
            case 'SET_WORKSPACE_SIZE': {
                // console.log('SET_PAN reducer', action);
                return {
                    width: action.width,
                    height: action.height,
                }
            }

            default: {
                // console.log('PAN DEFAULT');
                return state;
            }
        }
    },

    pan: function (state = { x: defaultPanX, y: defaultPanY }, action) {
        switch (action.type) {
            case 'PAN_BY': {
                // console.log('PAN_BY reducer', state, action);
                return {
                    x: state.x + action.dx,
                    y: state.y + action.dy
                }
            }
    
            case 'SET_PAN': {
                // console.log('SET_PAN reducer', action);
                return {
                    x: action.panX,
                    y: action.panY,
                }
            }

            default: {
                // console.log('PAN DEFAULT');
                return state;
            }
        }
    },

    zoom: function (state = defaultZoom, action) {
        // console.log('z state', state = 1, 'action', action);

        switch (action.type) {
            case 'ZOOM_BY': {
                // console.log('ZOOM_BY reducer', action);
                return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, state * action.dz));
            }
            case 'SET_ZOOM': {
                return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, action.z));
            }
            // case 'ZOOM_IN': {
            //     let zoomIndex = getZoomIndex(state) + 1;
            //     // zoomIndex = ZOOM_LEVELS[zoomIndex] == state ? zoomIndex+1 : zoomIndex+1;
            //     zoomIndex = Math.max(0, Math.min(ZOOM_LEVELS.length-1, zoomIndex));
            //     const z = ZOOM_LEVELS[zoomIndex];

            //     return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, z));
            // }
            // case 'ZOOM_OUT': {
            //     let zoomIndex = getZoomIndex(state);
            //     if (ZOOM_LEVELS[zoomIndex] == state) {
            //         zoomIndex--;
            //     }
            //     zoomIndex = Math.max(0, Math.min(ZOOM_LEVELS.length-1, zoomIndex));
            //     const z = ZOOM_LEVELS[zoomIndex];

            //     return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, z));
            // }

            case 'RESET_ZOOM': {
                return defaultZoom;
            }

            default: {
                // console.log('ZOOM DEFAULT');
                return state;
            }
        }
        return state;
    },

    zoomTarget: function (state = defaultZoom, action) {
        switch (action.type) {
            case 'SET_ZOOM': {
                return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, action.targetZ));
            }

            default: {
                // console.log('ZOOM DEFAULT');
                return state;
            }
        }
        return state;
    },
    zoomError: function (state = 0, action) {
        switch (action.type) {
            case 'SET_ZOOM': {
                return action.error || state;
            }

            default: {
                // console.log('ZOOM DEFAULT');
                return state;
            }
        }
        return state;
    }

});

export default cameraReducer;